import moment from 'moment';

export default {
  name: 'EcsKpiFormatter',

  methods: {
    kpiFormat(value, format, verbose = false) {
      let formattedData = value;

      switch (format) {
        case 'number':
          if (!formattedData) {
            formattedData = '0';
          }
          break;
        case 'seconds':
          if (!formattedData) {
            formattedData = 0;
          }
          formattedData += 's';
          break;
        case 'percentage':
          formattedData = `${Math.round(parseFloat(formattedData || 0) * 100)}%`;
          break;
        case 'date':
          if (formattedData === '0001-01-01T00:00:00.000+00:00') {
            formattedData = 'Not registered.';
          } else {
            formattedData = verbose ? moment(formattedData).format('LLL') : moment(formattedData).format('L');
          }
          break;
        case 'duration':
          const duration = (formattedData || '').replace(/\..*$/g, '');
          formattedData = this.buildDurationFormat(verbose, duration);
          break;
        case 'time':
          const time = moment.utc(formattedData * 1000);
          formattedData = time.format('mm:ss');
          break;
      }
      return formattedData;
    },
    buildDurationFormat(verbose, duration) {
      let formattedData = '';
      if (verbose) {
        const time = duration.split(':').map(piece => parseInt(piece));
        const hTime = `${time[0]}h `;
        const mTime = `${time[1]}m `;
        const sTime = `${time[2]}s`;
        formattedData = `${time[0] ? hTime : ''}${time[1] ? mTime : ''}${time[2] ? sTime : ''}`;
        if (!formattedData.trim().length) {
          formattedData = '0s';
        }
      } else {
        const seconds = moment.duration(duration).asSeconds() | 0;
        const minutes = moment.duration(duration).asMinutes();
        const hours = moment.duration(duration).asHours();

        formattedData = `${seconds}s`;

        if (seconds >= 60) {
          formattedData = `${minutes.toFixed(1)}m`;
        } else if (minutes >= 60) {
          formattedData = `${hours.toFixed(1)}h`;
        }
      }
      return formattedData;
    }
  }
};
